export const SuperscriptIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2 6C11.2 5.60055 11.255 5.2539 11.3652 4.96005C11.48 4.66162 11.666 4.39073 11.9231 4.14738C12.1802 3.90404 12.5337 3.66529 12.9837 3.43113C13.2224 3.30257 13.4038 3.19467 13.5278 3.10744C13.6563 3.01561 13.7482 2.92149 13.8033 2.82507C13.8629 2.72865 13.8928 2.61157 13.8928 2.47383C13.8928 2.26263 13.8239 2.09504 13.6862 1.97107C13.5484 1.84252 13.3533 1.77824 13.1008 1.77824C12.8253 1.77824 12.6049 1.85629 12.4396 2.0124C12.2743 2.1685 12.1733 2.39578 12.1366 2.69421L11.2137 2.63912C11.2596 2.12489 11.4456 1.72314 11.7716 1.43388C12.1022 1.14463 12.5452 1 13.1008 1C13.4543 1 13.7596 1.06198 14.0168 1.18595C14.2785 1.30533 14.4759 1.47521 14.609 1.69559C14.7468 1.91598 14.8157 2.1708 14.8157 2.46006C14.8157 2.71258 14.772 2.92608 14.6848 3.10055C14.6022 3.27502 14.469 3.43572 14.2854 3.58264C14.1063 3.72957 13.8469 3.89256 13.5071 4.07163C13.1123 4.28283 12.8115 4.48944 12.6049 4.69146C12.3983 4.88889 12.2881 5.06566 12.2743 5.22176H14.8157V6H11.2Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.21967 5.21967C1.51256 4.92678 1.98744 4.92678 2.28033 5.21967L9.78033 12.7197C10.0732 13.0126 10.0732 13.4874 9.78033 13.7803C9.48744 14.0732 9.01256 14.0732 8.71967 13.7803L1.21967 6.28033C0.926777 5.98744 0.926777 5.51256 1.21967 5.21967Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.78033 5.21967C9.48744 4.92678 9.01256 4.92678 8.71967 5.21967L1.21967 12.7197C0.926777 13.0126 0.926777 13.4874 1.21967 13.7803C1.51256 14.0732 1.98744 14.0732 2.28033 13.7803L9.78033 6.28033C10.0732 5.98744 10.0732 5.51256 9.78033 5.21967Z"
      fill="currentColor"
    />
  </svg>
)
